import React, { useState } from "react";
import { Form } from "react-bulma-components";
import { Button } from "react-bulma-components";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import { createSetDataFreshAction } from "../../../actions/dataActions";
import { getDataFresh } from "../../../state/selectors";
import { Icon } from "react-bulma-components";

function CostCentreRow({
  costCentreData,
  index,
  onCostCentreUpdate,
  endpoint
}) {
  const dispatch = useDispatch();
  const [costCentre, setCostCentre] = useState(costCentreData);
  const [editable, setEditable] = useState(false);
  let dataFresh = useSelector(getDataFresh);

  const submitUpdate = e => {
    e.stopPropagation();
    const url = endpoint + "costcentre/" + costCentre.id;
    const conf = {
      method: "put",
      data: costCentre,
      url
    };

    axios(conf).then(() => {
      setEditable(false);
      dispatch(createSetDataFreshAction(dataFresh + 1));
    });
  };

  const onChange = e => {
    let newCostCentre = { ...costCentre };
    newCostCentre[e.target.name] = e.target.value || null;
    setCostCentre(newCostCentre);
    onCostCentreUpdate(index, newCostCentre);
  };

  const onEdit = e => {
    e.stopPropagation();
    setEditable(!editable);
  };

  const onDelete = e => {
    const url = endpoint + "costcentre/" + costCentre.id;
    const conf = { method: "delete", url };
    axios(conf).then(response =>
      dispatch(createSetDataFreshAction(dataFresh + 1))
    );
  };


  return (
    <tr key={costCentreData.id}>
      <td>
        <Form.Field onClick={e => e.stopPropagation()} className="has-addons">
          <Form.Control>
            <Form.Input
              onChange={onChange}
              category="text"
              name="name"
              value={costCentre.name}
              disabled={!editable}
            />
          </Form.Control>
          {editable ? (
            <Form.Control>
              <Button color="success" onClick={submitUpdate}>
                Save
              </Button>
            </Form.Control>
          ) : (
            <Form.Control>
              <Button onClick={onEdit}>Edit</Button>
            </Form.Control>
          )}
        </Form.Field>
      </td>
      <td className={"is-narrow"}>
        <Button color={"danger"} onClick={onDelete}>
          Delete X
        </Button>
      </td>
    </tr>
  );
}

export default CostCentreRow;
